import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    
    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    const handleBackClick = () => {
        const userConfirmed = window.confirm("Do you want to go back to login page?");
        if (userConfirmed) {
            window.location.href = "https://www.charakan.info/";
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={handleBackClick}>
                    LAWRA
                </Link>
                <div className='menu-icon' onClick={toggleNavbar}>
                    <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                        <Link to='/home' className='nav-links' onClick={toggleNavbar}>
                            Home
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='/AboutUs' className='nav-links' onClick={toggleNavbar}>
                            About Us
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='/assist' className='nav-links' onClick={toggleNavbar}>
                            Research Assistant
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link to='/chatbot' className='nav-links' onClick={toggleNavbar}>
                            Chatbot
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default NavBar;
